import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { CreateButton } from 'react-admin'

import { white, orange } from '../../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: orange,
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '29px',
    paddingRight: '29px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: white,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginTop: '-40px',
    marginRight: '34px',
  },
}))

export const CreateActionButton = ({ label, title, ...props }) => {
  const classes = useStyles()
  return (
    <CreateButton
      {...props}
      className={classes.button}
      icon={<></>}
      label={label}
      title={title}
    />
  )
}
